import type { OptionTs } from "@ps-bridge/interop";
import * as Option from "@utils/Option";

type OptionStringLike =
  | OptionTs<string>
  | string;

type OptionStringRecord = Record<"value" | "value0" | "_0" | "_1", string>;

const readRecordString = (value: OptionStringLike): OptionTs<string> => {
  if (!value || typeof value !== "object") {
    return Option.none();
  }

  const record = value as never as OptionStringRecord;
  const candidates = [record.value, record.value0, record._0, record._1];
  const candidate = candidates.find((item) => typeof item === "string");
  return typeof candidate === "string" ? Option.some(candidate) : Option.none();
};

export const readOptionString = (value: OptionStringLike): string => {
  if (!value) {
    return "";
  }
  if (typeof value === "string") {
    return value;
  }

  return Option.fold(
    readRecordString(value),
    () =>
      Option.fold(
        value,
        () => "",
        (inner) => (typeof inner === "string" ? inner : ""),
      ),
    (recordString) => recordString,
  );
};
